import { DEMANDE_SEJOUR_STATUTS } from "@vao/shared-bridge";

const defaultStatus = {
  BROUILLON: DEMANDE_SEJOUR_STATUTS.BROUILLON,
  TRANSMISE: DEMANDE_SEJOUR_STATUTS.TRANSMISE,
  EN_COURS: DEMANDE_SEJOUR_STATUTS.EN_COURS,
  A_MODIFIER: DEMANDE_SEJOUR_STATUTS.A_MODIFIER,
  REFUSEE: DEMANDE_SEJOUR_STATUTS.REFUSEE,
  ATTENTE_8_JOUR: DEMANDE_SEJOUR_STATUTS.ATTENTE_8_JOUR,
  TRANSMISE_8J: DEMANDE_SEJOUR_STATUTS.TRANSMISE_8J,
  EN_COURS_8J: DEMANDE_SEJOUR_STATUTS.EN_COURS_8J,
  A_MODIFIER_8J: DEMANDE_SEJOUR_STATUTS.A_MODIFIER_8J,
  VALIDEE_8J: DEMANDE_SEJOUR_STATUTS.VALIDEE_8J,
  REFUSEE_8J: DEMANDE_SEJOUR_STATUTS.REFUSEE_8J,
  ANNULEE: DEMANDE_SEJOUR_STATUTS.ANNULEE,
  ABANDONNEE: DEMANDE_SEJOUR_STATUTS.ABANDONNEE,
  SEJOUR_EN_COURS: DEMANDE_SEJOUR_STATUTS.SEJOUR_EN_COURS,
  TERMINEE: DEMANDE_SEJOUR_STATUTS.TERMINEE,
};

const statusWithoutDraft = Object.fromEntries(
  Object.entries(defaultStatus).filter(
    ([key]) => key !== defaultStatus.BROUILLON,
  ),
);

export default {
  defaultStatus,
  statusWithoutDraft,
};
